import script from "./AutoSuggest.vue?vue&type=script&setup=true&lang=js"
export * from "./AutoSuggest.vue?vue&type=script&setup=true&lang=js"

import "./AutoSuggest.vue?vue&type=style&index=0&id=06a5f0f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06a5f0f0"]])

export default __exports__